import styled from 'styled-components'

interface IExternalPaymentMethodFormFieldsStyledProps {}

export const ExternalPaymentMethodFormFieldsStyled = styled.div<IExternalPaymentMethodFormFieldsStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  padding: ${(props) => props.theme.space.medium};

  flex-grow: 1;
  overflow: auto;
`
